/**
 * 心跳中间件
 * @param  {[type]} store [description]
 * @return {[type]}       [description]
 */

import * as $$BASE from '../actions/baseAction'
import * as USER_TYPE from '../constants/types/userTypes'

export default store => next => action => {

 	if(!action.payload || !action.payload.url || !window.AUTH_EXPIRESIN) {
        return next(action);
    }

    if(window.heartbeatTimer){
    	window.clearInterval(window.heartbeatTimer);
    } 
    let counter = 1;
    // N秒后超时
    window.heartbeatTimer = window.setInterval(function(){
    	counter ++;
    	if (counter == window.AUTH_EXPIRESIN) {
    		window.clearInterval(window.heartbeatTimer);
    		store.dispatch( $$BASE.openAlert('登录超时，请重新登录') ) 
    		store.dispatch({type: USER_TYPE.LOGOUT}) 
    	}
    }, 1000)

    return next(action);
}
